/** @jsx jsx */
import {Component} from 'react'
import {jsx} from '@instructure/emotion'
import {withStyleOverrides} from '@instructure/quiz-core'
import PropTypes from 'prop-types'
import t from 'format-message'

import generateStyle from './styles'

class SkipToContentUnstyled extends Component {
  static displayName = 'SkipToContent'
  static componentId = 'QuizzesSkipToContent'

  static propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    isNewTopNavBar: PropTypes.bool,
    makeStyles: PropTypes.func,
    styles: PropTypes.object,
  }

  static defaultProps = {
    isNewTopNavBar: false,
  }

  componentDidMount() {
    this.props.makeStyles()
  }

  componentDidUpdate() {
    this.props.makeStyles()
  }

  focusContent() {
    const mains = document.querySelectorAll('div[role="region"]')
    mains[mains.length - 1].focus()
  }

  render() {
    return (
      <button
        type="button"
        className="skipNavigationLink"
        css={this.props.styles.skipNavigationLink}
        onClick={this.focusContent}
      >
        {t('Skip To Quiz Content')}
      </button>
    )
  }
}

const SkipToContent = withStyleOverrides(generateStyle, null)(SkipToContentUnstyled)
export default SkipToContent
